import { Button } from 'foundations-components/transitional/components/Button';
import AbstractRouterLink from './internal/AbstractRouterLink';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A [`Button`](https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-button--basic)
 * type component with router support.
 */
export default function RouterButton(props) {
  return /*#__PURE__*/_jsx(AbstractRouterLink, Object.assign({}, props, {
    component: Button
  }));
}